export default {
  beforeMount(el: HTMLElement, binding: any) {
    const val = binding.value
    const left = val.left
    const right = val.right
    el.style.left = left + 'px'
    el.style.right = right + 'px'
  },
  mounted(el: HTMLElement) {},
  updated(el: HTMLElement, binding: any) {},
}
